/* fc-pp-recently.js (2026-10-12 speed pass): the recently-viewed rail (localStorage list, product fetches, nav).
   Moved out of sections/fc-pp-recently.liquid so browsers cache it across product
   pages; the root is #fc-pp-recently and per-instance values travel as data
   attributes (or the JSON config script). The bodies are the former inline
   scripts, unchanged apart from those lookups. Re-initialises on
   shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initRecently(section) {

  var STORAGE_KEY = 'fc:recently_viewed';
  var MAX_STORED = 20;
  var currentHandle = (section.getAttribute('data-current-handle') || '').trim();
  var maxItems = parseInt(section.getAttribute('data-max-items'), 10) || 8;
  var track = section.querySelector('[data-fc-rec-track]');

  /* Short-title map populated by Liquid above. Lookup: titleMap[handle].
     Falls back to p.title (full SEO title) if handle isn't in the map. */
  var titleMap = {};
  try {
    var fcTitlesEl = document.querySelector('[data-fc-product-titles]');
    if (fcTitlesEl) titleMap = JSON.parse(fcTitlesEl.textContent) || {};
  } catch(e) {}

  function readList(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) { return []; }
  }
  function writeList(list){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e){}
  }

  // Track current product view (only when we're on a product page)
  var list = readList();
  if(currentHandle){
    list = list.filter(function(h){ return h !== currentHandle; });
    list.unshift(currentHandle);
    if(list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    writeList(list);
  }

  // Build display list: skip the product we're currently viewing
  var displayHandles = list.filter(function(h){ return h && h !== currentHandle; }).slice(0, maxItems);
  if(displayHandles.length === 0){ return; } // section stays hidden

  function formatMoney(cents){
    if(window.Shopify && typeof window.Shopify.formatMoney === 'function'){
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_with_currency_format || window.Shopify.money_format || '${{amount}}'); } catch(e){}
    }
    return '$' + (Number(cents)/100).toFixed(2);
  }

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function buildCard(p){
    if(!p || !p.handle) return '';
    var url = p.url || ('/products/' + p.handle);
    /* Prefer the short metafield title; fall back to the full SEO title. */
    var title = esc(titleMap[p.handle] || p.title || '');
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var priceNow = formatMoney(p.price != null ? p.price : (p.price_min || 0));
    var compareVal = (p.compare_at_price_min && p.compare_at_price_min > (p.price || 0)) ? p.compare_at_price_min : (p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : 0);
    var priceWas = compareVal ? formatMoney(compareVal) : '';
    var priceCents = (p.price != null ? p.price : (p.price_min || 0));
    return '<div class="fc-rec-card">'
      + '<a href="' + esc(url) + '" class="fc-rec-card__link" aria-label="' + title + '"></a>'
      + '<div class="fc-rec-card__media">'
        + (img ? '<img src="' + esc(img) + '" alt="' + title + '" loading="lazy">' : '')
      + '</div>'
      + '<h3 class="fc-rec-card__title">' + title + '</h3>'
      + '<div class="fc-rec-card__price"'
        + ' data-fc-product-price="' + priceCents + '"'
        + ' data-fc-product-handle="' + esc(p.handle) + '"'
      + '>'
        + '<span class="fc-rec-card__price-now">' + priceNow + '</span>'
        + (priceWas ? '<span class="fc-rec-card__price-was">' + priceWas + '</span>' : '')
      + '</div>'
    + '</div>';
  }

  // Render skeletons immediately so the section shows something while we fetch
  track.innerHTML = displayHandles.map(function(){ return '<div class="fc-rec-card"><div class="fc-rec-skel"></div></div>'; }).join('');
  section.hidden = false;

  Promise.all(displayHandles.map(function(handle){
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error(); return r.json(); })
      .catch(function(){ return null; });
  })).then(function(products){
    products = products.filter(function(p){ return p && p.handle; });
    if(products.length === 0){
      section.hidden = true;
      // Clean stale handles
      writeList([]);
      return;
    }
    track.innerHTML = products.map(buildCard).join('');
    setupNav();
    if (typeof window.fcAnnSyncDiscount === 'function') window.fcAnnSyncDiscount();
  });

  // Re-apply discount when the announcement bar's toggle changes.
  document.addEventListener('fc:discount-changed', function(){
    if (typeof window.fcAnnSyncDiscount === 'function') window.fcAnnSyncDiscount();
  });

  function setupNav(){
    var prev = section.querySelector('[data-fc-rec-nav="prev"]');
    var next = section.querySelector('[data-fc-rec-nav="next"]');
    if(!prev || !next) return;
    function step(dir){
      var card = track.querySelector('.fc-rec-card');
      var w = card ? (card.offsetWidth + 20) : 280;
      track.scrollBy({left: dir * w, behavior: 'smooth'});
    }
    prev.addEventListener('click', function(){step(-1);});
    next.addEventListener('click', function(){step(1);});
    function updateDisabled(){
      var canLeft = track.scrollLeft > 2;
      var canRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 2;
      if(canLeft) prev.removeAttribute('disabled'); else prev.setAttribute('disabled','');
      if(canRight) next.removeAttribute('disabled'); else next.setAttribute('disabled','');
    }
    track.addEventListener('scroll', updateDisabled, {passive:true});
    window.addEventListener('resize', updateDisabled);
    setTimeout(updateDisabled, 50);
  }
  }
  function init() {
    var section = document.getElementById('fc-pp-recently');
    if (!section || section.getAttribute('data-fc-init') === '1') return;
    section.setAttribute('data-fc-init', '1');
    initRecently(section);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-pp-recently')) init();
  });
})();
